import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService, GRSSUserRoles, ValueIdPair } from 'src/app/_services/app.service';
import { ManageGeneralMarketsComponent } from '../manage-general-markets.component';

@Component({
    selector: 'app-add-test',
    templateUrl: './add-test.component.html',
    standalone: false
})
export class AddTestComponent implements OnInit {

  test: Test;
  operatorRoleName: string = GRSSUserRoles.Operator;

  constructor(public service: AppService, @Inject('BASE_URL') private baseUrl: string, public dialogRef: MatDialogRef<ManageGeneralMarketsComponent>, @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
    this.PopulateForm();
  }

  PopulateForm(): void {
    this.test = {
      testId: this.data.testId,
      name: this.data.name,
      defaultMessage: this.data.defaultMessage,
      messages: this.data.messages,
      enabled: this.data.enabled,
      verbose: this.data.verbose
    }
  }

  OnSaveTest() {
    if (this.test.enabled) {
      this.dialogRef.close(this.test);
    } else {
      this.dialogRef.close(null);
    }
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(null);
  }
}

interface Test {
  testId: string;
  name: string;
  defaultMessage: string;
  messages: ValueIdPair[];
  enabled: boolean;
  verbose: boolean;
}